if ( $('#stepstone-contact-form #phone').length ) {
    $('#stepstone-contact-form #phone').mask('(000) 000-0000');
}

// Hide errors on input change
$('#stepstone-contact-form input, #stepstone-contact-form select').on('input change', function () {
    $(this).closest('.form-group').removeClass('has-error');
    $(this).closest('.form-group').find('.form-group-error').fadeOut('fast');
    $('.contact-form-response').fadeOut('fast');
    $('#stepstone-contact-form').find('.submit-group .form-group-error').fadeOut('fast');
});

$('#stepstone-contact-form').on('submit', function (e) {
    e.preventDefault();

    var allowSubmit = true,
        contactForm = $(this),
        submitBtn = contactForm.find('button[type="submit"]'),
        subject = $('#subject'),
        firstName = $('#first-name'),
        lastName = $('#last-name'),
        phone = $('#phone'),
        email = $('#email'),
        city = $('#city'),
        state = $('#state'),
        message = $('#message');

    // Hide all errors
    contactForm.find('.form-group-error').fadeOut('fast');

    // Disable Submit button
    submitBtn.addClass('disabled').prop('disabled', true).find('.fa').addClass('fa-circle-o-notch fa-spin');

    // Subject
    if ( subject.find(':selected').val() == '' || subject.find(':selected').val() == '-1' ) {
        subject.closest('.form-group').addClass('has-error');
        subject.closest('.form-group').find('.form-group-error').fadeIn('fast');
        allowSubmit = false;
    }

    // First Name
    if ( $.trim(firstName.val()) == '') {
        firstName.closest('.form-group').addClass('has-error');
        firstName.closest('.form-group').find('.form-group-error').fadeIn('fast');
        allowSubmit = false;
    }

    // Last Name
    if ( $.trim(lastName.val()) == '') {
        lastName.closest('.form-group').addClass('has-error');
        lastName.closest('.form-group').find('.form-group-error').fadeIn('fast');
        allowSubmit = false;
    }

    // Phone
    if ( $.trim(phone.cleanVal()) == '') {
        phone.closest('.form-group').addClass('has-error');
        phone.closest('.form-group').find('.form-group-error.required').fadeIn('fast');
        allowSubmit = false;
    } else
    // Phone Format
    if ( /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/gm.test(phone.cleanVal()) !== true) {
        phone.closest('.form-group').addClass('has-error');
        phone.closest('.form-group').find('.form-group-error.format').fadeIn('fast');
        allowSubmit = false;
    }

    // Email
    if ( $.trim(email.val()) == '') {
        email.closest('.form-group').addClass('has-error');
        allowSubmit = false;
    }

    // City
    if ( $.trim(city.val()) == '') {
        city.closest('.form-group').addClass('has-error');
        city.closest('.form-group').find('.form-group-error').fadeIn('fast');
        allowSubmit = false;
    }

    // State
    if ( state.find(':selected').val() == '' || state.find(':selected').val() == '-1' ) {
        state.closest('.form-group').addClass('has-error');
        state.closest('.form-group').find('.form-group-error').fadeIn('fast');
        allowSubmit = false;
    }

    // Message
    if ( $.trim(message.val()) == '') {
        message.closest('.form-group').addClass('has-error');
        message.closest('.form-group').find('.form-group-error').fadeIn('fast');
        allowSubmit = false;
    }

    if ( allowSubmit == true ) {
        // Hide all errors
        contactForm.find('.form-group-error').fadeOut('fast');
        // Unbind submit hook
        contactForm.off('submit');
        // Google Analytics Event Tracking
        StepStone.trackEvent('submit', 'contact', 'user_submit_new_contact_form_' + subject.find(':selected').val().toLowerCase().trim().replace(/[\W_]+/g, '_') );
        // Submit form
        contactForm[0].submit();
    } else {
        contactForm.find('.submit-group .form-group-error').fadeIn('fast');
        setTimeout(function() {
            // Enable Submit button
            submitBtn.removeClass('disabled').prop('disabled', false).find('.fa').removeClass('fa-circle-o-notch fa-spin');
        }, 1);
    }

});

function stateAndCountyFields(elem, activeElem, gfid) {

    $(elem).hide();
    $(elem).after('<div class="ginput_container_select"><select id="county-dropdown"></select></div>');

    $(activeElem).change(function() {
        var selectedState = $(activeElem).val();
        $(gfid + ' #county-dropdown').find('option').remove();
        $.ajax({
            url: "https://locations.brightspringhealth.com/wp-json/stepstone/v1/counties/" + selectedState,
            method: 'GET',
        }).done(function (data) {
            $(elem).parent().find('select').append('<option value="">Select County</option>');
            for (var i = 0; i < data.length; i++) {
                $(elem).parent().find('select').append('<option value="' + data[i].county + '">' + data[i].county + '</option>');
            }
            $(elem).parent().find('select').append('<option value="Other">Other</option>');
        });
    });

    $(gfid + ' #county-dropdown').change(function(){
        $(elem).val( $(this).val() );
    });

}

stateAndCountyFields('#gform_1 #input_1_14', '#gform_1 #input_1_13', '#gform_1');
stateAndCountyFields('#gform_3 #input_3_15', '#gform_3 #input_3_13', '#gform_3');

// Code for the request services form


// Code for the become a foster parent form
